import type { PopupPositionsType } from "@skbkontur/react-ui";

export const importTourStep = {
    id: "candyform_import",
    header: "Не теряйте данные",
    controlId: "import_button",
    content: "Переносите данные из формы предыдущего формата.",
    positions: ["right middle"] as PopupPositionsType[],
    group: ["menu"],
    order: 45,
    isEnabled: true,
};
